import { Theme } from '@mui/material';

export const MuiPickersYear = {
  styleOverrides: {
    yearButton: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.surface.onSurfaceVar,
      '&.Mui-selected': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: theme.palette.primary.onColor,
      },
    }),
  },
};
